import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { local, errMsg } from "@/lib/api";
import { Loader } from "@/components/Loader";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";

export function SATicker() {
  const [cfg, setCfg] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    local.get("/ticker").then((r) => setCfg({ colors: ["#FF6F61", "#B39DDB", "#7EC8E3"], ...r.data })).catch(() => setCfg({ colors: ["#FF6F61", "#B39DDB", "#7EC8E3"], enabled: true, message: "" }));
  }, []);

  if (!cfg) return <Loader full />;
  const set = (k, v) => setCfg((c) => ({ ...c, [k]: v }));
  const setColor = (i, v) => setCfg((c) => { const a = [...(c.colors || [])]; a[i] = v; return { ...c, colors: a }; });

  const save = async () => {
    setSaving(true);
    try {
      await local.post("/ticker", { enabled: cfg.enabled !== false, message: cfg.message, colors: cfg.colors, app_store_url: cfg.app_store_url || "", play_store_url: cfg.play_store_url || "" });
      toast.success("Ticker updated — live across FHAPAS on next page load");
    } catch (e) { toast.error(errMsg(e)); }
    finally { setSaving(false); }
  };

  return (
    <div className="max-w-2xl">
      <h1 className="font-display text-2xl font-bold text-white sm:text-3xl">Announcement Ticker</h1>
      <p className="mt-1 text-sm text-slate-400">Edit the global banner shown on every screen — no code change needed.</p>
      <div className="mt-6 space-y-5 rounded-xl border border-white/10 bg-white/[0.03] p-6">
        <label className="flex items-center gap-2 text-sm text-slate-200"><Switch data-testid="ticker-enabled" checked={cfg.enabled !== false} onCheckedChange={(v) => set("enabled", v)} /> Show ticker</label>
        <div className="space-y-1.5"><Label className="text-slate-300">Message</Label><Textarea data-testid="ticker-message" rows={3} value={cfg.message || ""} onChange={(e) => set("message", e.target.value)} className="border-white/10 bg-slate-800 text-white" /></div>
        <div>
          <Label className="text-slate-300">Background colours (loop)</Label>
          <div className="mt-2 flex gap-3">{(cfg.colors || []).map((c, i) => <input key={i} data-testid={`ticker-color-${i}`} type="color" value={c} onChange={(e) => setColor(i, e.target.value)} className="h-10 w-16 cursor-pointer rounded-lg border border-white/10 bg-transparent" />)}</div>
        </div>
        <div className="grid gap-4 sm:grid-cols-2">
          <div className="space-y-1.5"><Label className="text-slate-300">App Store URL</Label><Input data-testid="ticker-appstore" value={cfg.app_store_url || ""} onChange={(e) => set("app_store_url", e.target.value)} placeholder="https://apps.apple.com/…" className="border-white/10 bg-slate-800 text-white" /></div>
          <div className="space-y-1.5"><Label className="text-slate-300">Google Play URL</Label><Input data-testid="ticker-playstore" value={cfg.play_store_url || ""} onChange={(e) => set("play_store_url", e.target.value)} placeholder="https://play.google.com/…" className="border-white/10 bg-slate-800 text-white" /></div>
        </div>
        <div className="overflow-hidden rounded-lg">
          <div className="px-3 py-2 text-center text-sm font-bold text-white" style={{ backgroundColor: (cfg.colors || ["#FF6F61"])[0] }} data-testid="ticker-preview">{cfg.message || "Preview"}</div>
        </div>
        <Button data-testid="ticker-save" onClick={save} disabled={saving} className="bg-teal-600 hover:bg-teal-700">{saving ? "Saving…" : "Save & publish"}</Button>
      </div>
    </div>
  );
}
